import { whenTabShown } from "./overlay.js"

// The first-run intro sits above every other overlay; prompts that would open under it wait until it is done.
export const ONBOARDING_SEEN_KEY = "onboarding_intro_seen"
export const ONBOARDING_DONE_EVENT = "onboarding:done"

export function onboardingSeen(storage = globalThis.localStorage) {
  try { return storage?.getItem(ONBOARDING_SEEN_KEY) === "1" } catch { return false }
}

export function onboardingPending(doc = document, storage = globalThis.localStorage) {
  return Boolean(doc.getElementById("onboarding-intro")) && !onboardingSeen(storage)
}

// Runs callback once the intro is done and the tab is on screen (now, if both hold). Returns a cancel function for
// disconnect().
export function afterOnboarding(callback, { doc = document, win = window, storage = globalThis.localStorage } = {}) {
  let cancelShown = () => {}
  const run = () => { cancelShown = whenTabShown(callback, win) }
  if (!onboardingPending(doc, storage)) {
    run()
    return () => cancelShown()
  }
  win.addEventListener(ONBOARDING_DONE_EVENT, run, { once: true })
  return () => {
    win.removeEventListener(ONBOARDING_DONE_EVENT, run)
    cancelShown()
  }
}
